module.exports = __webpack_public_path__ + "static/img/upload-android.2288ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload-android.png
// module id = gQ4A
// module chunks = 1